<template>
    <BreadCrumb PageTitle="Paiement Paypal d'un BESC" />
    <PaiementPaypal />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PaiementPaypal from "@/components/BESC/PaiementPaypal.vue";
  
    export default defineComponent({
      name: "PaiementPaypalPage",
      components: {
        BreadCrumb,
        PaiementPaypal,
      },
    });
  </script>